const translations = {
    mapError: 'Error creating map, please try again later',
    mapSuccess: 'Map created successfully'
};

export default translations;
